export const columns_1 = [
  {
    title: 'Ojo',
    dataIndex: 'ojo',
    key: 'ojo',
    editable: false,
    width: '12%',
  },
  {
    title: 'Eje',
    dataIndex: 'eje',
    key: 'eje',
    editable: true,
    width: '12.5%',
  },
  {
    title: 'Cilindro',
    dataIndex: 'cilindro',
    key: 'cilindro',
    editable: true,
    width: '12.5%',
  },
  {
    title: 'Esf. Lejos',
    dataIndex: 'esfLejos',
    key: 'esfLejos',
    editable: true,
    width: '12.5%',
  },
  {
    title: 'Esf. Cerca',
    dataIndex: 'esfCerca',
    key: 'esfCerca',
    editable: true,
    width: '12.5%',
  },
  {
    title: 'Adición',
    dataIndex: 'adicion',
    key: 'adicion',
    editable: true,
    width: '12.5%',
  },
  {
    title: 'AVSC',
    dataIndex: 'avsc',
    key: 'avsc',
    editable: true,
    width: '12.5%',
  },
  {
    title: 'AVCC',
    dataIndex: 'avcc',
    key: 'avcc',
    editable: true,
    width: '12.5%',
  },
];

export const columns_2 = [
  {
    title: 'Ojo',
    dataIndex: 'ojo',
    key: 'ojo',
    width: '12%',
  },
  {
    title: 'Queratometria',
    dataIndex: 'queratometria',
    key: 'quetatometria',
    width: '88%',
    editable: true,
  },
];

export const columns_3 = [
  {
    title: 'Ojo',
    dataIndex: 'ojo',
    key: 'ojo',
    width: '12%',
  },
  {
    title: 'Eje',
    dataIndex: 'eje',
    key: 'eje',
    editable: true,
    width: '12.5%',
  },
  {
    title: 'Cilindro',
    dataIndex: 'cilindro',
    key: 'cilindro',
    editable: true,
    width: '12.5%',
  },
  {
    title: 'Esf. Lejos',
    dataIndex: 'esfLejos',
    key: 'esfLejos',
    editable: true,
    width: '12.5%',
  },
  {
    title: 'Esf. Cerca',
    dataIndex: 'esfCerca',
    key: 'esfCerca',
    editable: true,
    width: '12.5%',
  },
  {
    title: 'Adición',
    dataIndex: 'adicion',
    key: 'adicion',
    editable: true,
    width: '12.5%',
  },
  {
    title: 'AVCC',
    dataIndex: 'avcc',
    key: 'avcc',
    editable: true,
    width: '12.5%',
  },
  {
    title: 'Ojo Dom.',
    dataIndex: 'ojoDom',
    key: 'ojoDom',
    editable: true,
    width: '12.5%',
    type: 'select',
    values: [{ key: 'Ninguno', value: 'Ninguno' }, { key: 'D', value: 'D' }, { key: 'N', value: 'N' }],
    defaultValue: 'Ninguno',
  },
];
export const columns_4 = [
  {
    title: 'Ojo',
    dataIndex: 'ojo',
    key: 'ojo',
    width: '12%',
  },
  {
    title: 'Diámetro',
    dataIndex: 'diametro',
    key: 'diametro',
    editable: true,
    width: '22%',
  },
  {
    title: 'Diámetro Z.O.',
    dataIndex: 'diametrozo',
    key: 'diametrozo',
    editable: true,
    width: '22%',
  },
  {
    title: 'Radio',
    dataIndex: 'radio',
    key: 'radio',
    editable: true,
    width: '22%',
  },
  {
    title: 'Tipo de lente',
    dataIndex: 'tipoDeLente',
    key: 'tipoDeLente',
    editable: true,
    width: '22%',
  },
  /*
  {
    title: 'Acciones',
    dataIndex: 'acciones',
    key: 'acciones',
    render: acciones => (
      <Text>
        <a>{`${acciones.split(' ')[0]} ${acciones.split(' ')[1]} ` }</a>
        <Text style={{ color: '#E2E2E2' }}>
          {acciones.split(' ')[2]}
          {' '}
        </Text>
        <a>{ ` ${acciones.split(' ')[3]}` }</a>
      </Text>
    ),
  },
   */
];

export const columns_5 = [
  {
    title: 'Grad.',
    dataIndex: 'grad',
    key: 'grad',
    editable: true,
    width: '14%',
  },
  {
    title: 'Suc.',
    dataIndex: 'suc',
    key: 'suc',
    editable: true,
    width: '5%',
  },
  {
    title: 'Num.',
    dataIndex: 'num',
    key: 'num',
    editable: true,
    width: '7%',
  },
  {
    title: 'Fecha',
    dataIndex: 'fecha',
    key: 'fecha',
    editable: true,
    width: '14%',
  },
  {
    title: 'Resumen OI',
    dataIndex: 'resumen_oi',
    key: 'resumen_oi',
    editable: true,
    width: '25%',
  },
  {
    title: 'Resumen OD',
    dataIndex: 'resumen_od',
    key: 'resumen_od',
    editable: true,
    width: '25%',
  },
];
